module.exports = __webpack_public_path__ + "static/media/default-level-bg.2398e197.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/default-level-bg.png
// module id = 635
// module chunks = 1